import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Camera, History } from "lucide-react";

const KPI = [["accessi_area", "Accessi area"], ["preventivi_salvati", "Prev. salvati"], ["richieste_consulenza", "Consulenze"], ["proposte_emesse", "Proposte"], ["polizze_attivate", "Polizze"]];
const annoCorr = new Date().getFullYear();

const Delta = ({ a, b }) => {
  const d = a - b;
  if (!d) return null;
  return <span className={`ml-1.5 text-[11px] ${d > 0 ? "text-emerald-700" : "text-red-700"}`}>({d > 0 ? `+${d}` : d})</span>;
};

// Confronto dell'anno scelto con il precedente (fotografie di fine anno). Solo Agenzia.
export const ConfrontoAnni = ({ codice }) => {
  const [anno, setAnno] = useState(annoCorr);
  const [d, setD] = useState(null);
  const load = () => api.get(`/admin/accordi/confronto?anno=${anno}&codice=${codice || ""}`).then(({ data }) => setD(data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, [anno, codice]); // eslint-disable-line
  const fotografa = async () => {
    const esiste = d.anni_salvati.includes(anno - 1);
    if (esiste && !window.confirm(`La fotografia ${anno - 1} esiste già. Sovrascriverla con i numeri ricalcolati ora?`)) return;
    try { const { data } = await api.post(`/admin/accordi/storico/${anno - 1}${esiste ? "?sovrascrivi=1" : ""}`); toast.success(`Fotografia ${data.anno} salvata per ${data.accordi} accordi`); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!d) return null;
  return (
    <Card className="space-y-3 rounded-xl p-4" data-testid="confronto-anni">
      <div className="flex flex-wrap items-center gap-2">
        <History className="h-4 w-4 text-terracotta" />
        <span className="font-heading font-semibold text-forest">Confronto {anno} con {anno - 1}</span>
        <select value={anno} onChange={(e) => setAnno(Number(e.target.value))} data-testid="confronto-anno" className="h-8 rounded-md border px-2 text-sm">
          {Array.from({ length: 6 }, (_, i) => annoCorr - i).map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <span className="text-xs text-muted-foreground">{anno === annoCorr ? "Anno in corso fino a oggi. " : ""}Fotografie salvate: {d.anni_salvati.length ? d.anni_salvati.join(", ") : "nessuna"}</span>
        <Button size="sm" variant="outline" onClick={fotografa} data-testid="confronto-fotografa" className="ml-auto h-8 gap-1"><Camera className="h-3.5 w-3.5" />Salva fotografia {anno - 1}</Button>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow className="bg-sage/50"><TableHead>Accordo</TableHead>{KPI.map(([k, l]) => <TableHead key={k} className="text-right">{l}</TableHead>)}<TableHead className="text-right">% prev→polizza</TableHead></TableRow></TableHeader>
          <TableBody>
            {d.righe.map((r) => (
              <TableRow key={r.codice} data-testid={`confronto-row-${r.codice}`}>
                <TableCell><div className="font-mono text-xs text-forest">{r.codice}</div><div className="text-xs text-muted-foreground">{r.denominazione} · {anno - 1}: {r.precedente.fonte}</div></TableCell>
                {KPI.map(([k]) => <TableCell key={k} className="whitespace-nowrap text-right tabular-nums">{r.corrente[k]}<span className="text-xs text-muted-foreground"> / {r.precedente[k]}</span><Delta a={r.corrente[k]} b={r.precedente[k]} /></TableCell>)}
                <TableCell className="whitespace-nowrap text-right tabular-nums">{r.corrente.conv_preventivo_polizza}%<span className="text-xs text-muted-foreground"> / {r.precedente.conv_preventivo_polizza}%</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <p className="text-[11px] text-muted-foreground">Formato: {anno} / {anno - 1} e differenza. Il 1° gennaio la fotografia dell'anno chiuso si salva in automatico.</p>
    </Card>
  );
};
